import { c as _c } from "react/compiler-runtime";
import React from "react";
import styles from "./Teasers.module.scss";
import { TeasersItem, TeasersItemProps } from "../TeasersItem/TeasersItem";
export const Teasers: React.FC<{
  teasers: Array<TeasersItemProps & {
    _key: any;
  }>;
}> = t0 => {
  const $ = _c(4);
  const {
    teasers
  } = t0;
  let t1;
  if ($[0] !== teasers) {
    t1 = teasers.map(_temp);
    $[0] = teasers;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className={styles.teasers}>{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
function _temp(t0, i) {
  const {
    _key,
    id,
    title,
    paragraph,
    links,
    image
  } = t0;
  return <TeasersItem key={_key} id={id} title={title} paragraph={paragraph} links={links} image={image} inverted={i % 2 !== 0} />;
}